import React from "react";
import classNames from "classnames";

import { Avatar, IconButton, Tooltip, makeStyles } from "@material-ui/core";

import HStack from "../HStack";

import { getSubdomain, redirectToSubdomain } from "modules/core/utils/helpers";
import { coreRoutesConstants } from "modules/core/routes/routesConstants";
import { sendTrackingEvent } from "modules/core/api/tracking";
import { trackingEvents } from "modules/auth/config/tracking/events";

import { IUser } from "modules/user/types/entities";

interface IAccountSelectProps {
  accounts: IUser["accounts"];
}

const useStyles = makeStyles(theme => ({
  grid: {
    gap: 10,
    flexWrap: "wrap"
  },

  account: {
    "&:hover": {
      backgroundColor: "#bdbdbd",
      border: `2px solid ${theme.palette.primary.light}`
    },
    "&:focus": {
      backgroundColor: "#bdbdbd",
      border: `2px solid ${theme.palette.primary.light}`
    }
  },

  activeAccount: {
    border: `3px solid ${theme.palette.primary.main}`,
    padding: 1,
    backgroundClip: "content-box"
  }
}));

const AccountSelect: React.FC<IAccountSelectProps> = props => {
  const { accounts } = props;

  const classes = useStyles();

  return (
    <HStack className={classes.grid}>
      {accounts.map(account => {
        const isActive = account.subdomain === getSubdomain();

        return (
          <Tooltip key={account.subdomain} title={account.name}>
            <Avatar
              alt={account.name}
              src={account.logo || ""}
              component={IconButton}
              size="small"
              className={classNames(classes.account, {
                [classes.activeAccount]: isActive
              })}
              onClick={() => {
                sendTrackingEvent(trackingEvents.auth.switched_workspace);
                redirectToSubdomain(
                  account.subdomain,
                  coreRoutesConstants.dashboard.href()
                );
              }}
            >
              {account.name?.at(0)}
            </Avatar>
          </Tooltip>
        );
      })}
    </HStack>
  );
};

export default React.memo(AccountSelect);
